/**
 * The legal documents (Terms of service, Privacy policy, Data processing agreement), published on the landing site in
 * each language: where the app and the checkout site link to them.
 */

/** The site, where the legal documents are. */
const SITE = "https://revisa.work";
/** Each document's path, by language (the site's slugs, site/src/strings.ts). */
const LEGAL = {
  en: { terms: "/terms/", privacy: "/privacy/", dpa: "/dpa/", pricing: "/pricing/" },
  pt: { terms: "/pt-br/termos/", privacy: "/pt-br/privacidade/", dpa: "/pt-br/dpa/", pricing: "/pt-br/precos/" },
  it: { terms: "/it/termini/", privacy: "/it/privacy/", dpa: "/it/dpa/", pricing: "/it/prezzi/" },
};

export interface LegalUrls {
  terms: string;
  privacy: string;
  dpa: string;
  /** The plans and prices (the Terms link to them). */
  pricing: string;
}

/** The terms of service, privacy policy, data processing agreement (and pricing), in `lang` (English when the site lacks it). */
export function legalUrls(lang: string): LegalUrls {
  const code = lang.split("-")[0]?.toLowerCase();
  const paths = code === "pt" || code === "it" ? LEGAL[code] : LEGAL.en;
  return {
    terms: SITE + paths.terms,
    privacy: SITE + paths.privacy,
    dpa: SITE + paths.dpa,
    pricing: SITE + paths.pricing,
  };
}
